import { isWorkablePendingWorkspaceClient } from "../../invitations/pendingWorkspaceState";

const ACTIVE_CLIENT_STATUS = "active-string";
const DEFAULT_BLOCK_LABEL = "-";
const DEFAULT_WEEK_LABEL = "-";
const DEFAULT_WEEK_WORKOUTS = [
  false,
  false,
  false,
  false,
  false,
  false,
  false,
];

const normalizeString = (value) =>
  typeof value === "string" ? value.trim() : "";

const toPositiveInteger = (value) => {
  const parsed = Number(value);
  if (!Number.isFinite(parsed)) return 0;
  const integerValue = Math.floor(parsed);
  return integerValue > 0 ? integerValue : 0;
};

const normalizeWeekWorkouts = (weekWorkouts) => {
  if (!Array.isArray(weekWorkouts)) {
    return [...DEFAULT_WEEK_WORKOUTS];
  }

  const normalized = weekWorkouts.slice(0, 7).map((value) => value === true);
  while (normalized.length < 7) {
    normalized.push(false);
  }
  return normalized;
};

const isActiveClient = (client) =>
  normalizeString(client?.status) === ACTIVE_CLIENT_STATUS;

export const resolveDashboardBlockDisplay = (client) => {
  const blockName = normalizeString(client?.getBlockCurrentName);
  const hasValue = blockName !== "" && blockName !== DEFAULT_BLOCK_LABEL;

  return {
    label: hasValue ? blockName : DEFAULT_BLOCK_LABEL,
    hasValue,
  };
};

export const resolveDashboardWeekDisplay = (client) => {
  const currentWeek = toPositiveInteger(client?.getBlockCurrentWeek);
  const blockWeeks = toPositiveInteger(client?.getBlockWeeks);
  const hasValue = currentWeek > 0 && blockWeeks > 0;

  return {
    label: hasValue ? `${currentWeek} / ${blockWeeks}` : DEFAULT_WEEK_LABEL,
    hasValue,
  };
};

export const resolveDashboardWeekWorkoutsDisplay = (client) => {
  if (!isActiveClient(client) && !isWorkablePendingWorkspaceClient(client)) {
    return {
      weekWorkouts: [...DEFAULT_WEEK_WORKOUTS],
      readOnly: true,
    };
  }

  return {
    weekWorkouts: normalizeWeekWorkouts(client?.weekWorkouts),
    readOnly: false,
  };
};
